<template>
  <div 
  ref="elementRef"
  :style="{
    opacity: isVisible ? 1 : 0.01,
    transform: isVisible ? 'translateY(0)' : `translateY(${slideVal}px)`,
    transition: 'opacity 0.5s cubic-bezier(0.25, 0.8, 0.5, 1), transform 0.5s cubic-bezier(0.25, 0.8, 0.5, 1)',
    transitionDelay: `${delay}ms`
  }"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  slide: {
    type: String,
    default: 'up' //true, 'up', 'down'
  },
  delay: {
    default: 0
  },
})

const isVisible = ref(false)

const slideVal = computed(() => {
  return props.slide === 'down' ? -30 : 30
})

const elementRef = ref(null)

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        isVisible.value = true
      }
    })
  }, { threshold: 0 })

  // elementRef can be null if hydration bailed before this component's el
  // attached; skip observing (content stays visible via SSR markup) rather
  // than throwing inside app init.
  if (elementRef.value instanceof Element) {
    observer.observe(elementRef.value)
  } else {
    isVisible.value = true
  }
})
</script>